<template>
  <v-layout row wrap class="hidden-sm-and-down">
    <v-flex d-flex>
      <p class="subheading text-right">
        Date Range:
        <date-picker
          width="330"
          :shortcuts="shortcuts"
          clearable
          range
          confirm
          :v-model="modelName"
          :not-after="runDateUpper"
          lang="en"
          type="datetime"
          format="YYYY-MM-DD HH:mm"
          :minute-step="15"
        >
        </date-picker>
        <v-btn icon color="primary" @click="clickEvent()">
          <v-icon color="white">{{ icon }}</v-icon>
        </v-btn>
      </p>
    </v-flex>
  </v-layout>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    modelName: {
      type: String,
      required: true
    },
    clickEvent: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: 're-sync'
    }
  },
  data() {
    return {
      shortcuts: false,
      runDateUpper: ''
    }
  },
  created() {
    this.runDateUpper = moment()
      .subtract(1, 'days')
      .hour(23)
      .minute(45)
      .toDate()
  }
}
</script>
